<form [formGroup]="formGroup">
  <ng-container *ngFor="let code of codes">
    <mmx-code-modifiers-select
      [formControlName]="code"
      [code]="code"
    ></mmx-code-modifiers-select>
  </ng-container>
</form>
